import moment from "moment"
import { ILaundryShort } from "types/laundry"
import { ITableColumn } from "components/UI/organisms/Table/TableTypes"

import { Box, Flex, Text, Center, Image } from "@chakra-ui/react"
import Icon from "components/UI/atoms/Icon"
import StatusButton from "components/UI/molecules/StatusButton"

interface renderWorkingHoursArgs {
  workStartTime: string
  workEndTime: string
  is24: boolean
}

const getIconName = (isNew: boolean, hasChanges: boolean) => {
  let iconName = "edit"

  if (!hasChanges && isNew) {
    iconName = "eye"
  }

  return iconName
}

const renderBadge = (quantity: number) => (
  <Flex alignItems={"center"} justifyContent="center" background={"white"} h={"20px"} w="20px" borderRadius="50%" borderWidth={"1px"} borderColor="primary" fontSize={"10px"} color={"primary"} position={"absolute"} top={"-6px"} left={"25px"}>
    {quantity}
  </Flex>
)

const renderWorkingHours = ({ workStartTime, workEndTime, is24 }: renderWorkingHoursArgs) => (
  is24 ? (
    <Center w="30px" h="30px" border="1px solid" borderColor="success" borderRadius="base">
      <Text fontSize="ms" color="success">24</Text>
    </Center>
  ) : <Text fontWeight={600} fontSize={"12px"}>
    {`${moment(workStartTime).format("HH:mm")} - ${moment(workEndTime).format("HH:mm")}`}
  </Text>
)

export const getColumns = (T: any, navigeteToHistory: (id: number) => void): ITableColumn[] => [
  {
    key: "laundries.table.columns.name",
    label: T("laundries.table.columns.name"),
    render: (data: ILaundryShort) => <Box padding={"5px"}>
      <Image src={data?.logoUrl} alt="Company" width="45px" />
      <Text>{data?.name}</Text>
    </Box>,
  },
  {
    // laundries.table.columns.working_hours
    key: "laundries.table.columns.working_hours",
    label: T("laundries.table.columns.working_hours"),
    render: (data: ILaundryShort) => renderWorkingHours({
      workStartTime: data.workStartTime,
      workEndTime: data.workEndTime,
      is24: data.is24Houres
    })
  },
  {
    // laundries.table.columns.phone
    key: "laundries.table.columns.phone",
    label: T("laundries.table.columns.phone"),
    render: (data: ILaundryShort) => (
      <Text fontWeight={600} fontSize={"12px"} >{data?.phoneNumber}</Text>
    ),
  },
  {
    // laundries.table.columns.address
    key: "laundries.table.columns.address",
    label: T("laundries.table.columns.address"),
    render: (data: ILaundryShort) => (
      <Text fontWeight={600} fontSize={"12px"} >{data?.address}</Text>
    ),
  },
  {
    key: "laundries.table.columns.status",
    label: "",
    render: (data: ILaundryShort) => (
      <StatusButton isOpen={data.isOpen} isNew={data.isNew} hasChanges={data.changeRequestCount > 0} />
    ),
  },
  {
    key: "laundries.table.columns.changeRequests",
    label: "",
    render: (data: ILaundryShort) => (
      <Flex
        cursor="pointer"
        position={"relative"}
        alignItems={"center"}
        justifyContent="center"
        h={"40px"}
        w="40px"
        background={"primary"}
        onClick={() => data.changeRequestCount > 0 && navigeteToHistory(data.id)}
        borderRadius="50%"
        pointerEvents={`${(data.isNew || data.changeRequestCount === 0) ? "none" : "auto"}`}
        opacity={`${(data.isNew || data.changeRequestCount === 0) ? .5 : 1}`}
        marginLeft={window.innerWidth <= 1170 ? "50px" : "0"}
      >
        {data.changeRequestCount > 0 && renderBadge(data.changeRequestCount)}
        <Icon
          name={getIconName(data.isNew, data.changeRequestCount > 0)}
          iconStyles={{ width: "20px", height: "20px", fill: "white" }}
        />
      </Flex>
    ),
  },


]
